export const REGISTRATION_VIEWER_ROLES = ['admin', 'tec_tenant', 'root'];

export const EXPIRED_LABEL = 'Expirado — aguardando renovação';

const pad = (value) => String(value).padStart(2, '0');

export const canViewRegistrations = (role, phase0Validated, isMasterRootSession = false) =>
  REGISTRATION_VIEWER_ROLES.includes(role)
  && (phase0Validated === true || (role === 'root' && isMasterRootSession === true));

export const formatAddress = (ip, port) => {
  if (ip === null || ip === undefined || ip === '') return '';
  const host = String(ip).includes(':') ? `[${ip}]` : String(ip);
  return port === null || port === undefined ? String(ip) : `${host}:${port}`;
};

export const formatClock = (value) => {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
};

export const remainingSeconds = (contact, receivedAtMs, nowMs) =>
  contact.expiresInSeconds - Math.floor(Math.max(0, nowMs - receivedAtMs) / 1000);

export const formatExpiry = (contact, receivedAtMs, nowMs) => {
  const remaining = remainingSeconds(contact, receivedAtMs, nowMs);
  if (remaining <= 0) return EXPIRED_LABEL;
  return `${remaining}s (${formatClock(contact.expiresAt)})`;
};
